import { getToken, getData } from '@/utils/auth'

const state = {
    token: getToken(),
    data: getData(),
}
const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_DATA: (state, data) => {
        state.data = data
    },
}

export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}

